import React from 'react';
import { useField } from 'formik';
import { ValidationMessage } from '../../../Helpers/validation/validationMessage';

export const FormikTextareaField = ({ label, ...props }) => {

  const [field, meta] = useField(props);
  return (
    <>
      <textarea {...field} {...props} aria-required="true" />
      <ValidationMessage {...meta} />
    </>
  )
}